import { gql } from '@apollo/client'
import {
  Docview,
  RecommendedDocuments,
  ViewLockContext,
  ViewLockWrapper,
} from '@jusbrasil-web/docview/core'
import { ServerSidePersistentAlertBanner } from '@jusbrasil-web/shared-persistent-alert-banner'

import {
  LawsuitSubjects,
  MotionAppbar,
  MotionBreadcrumb,
  MotionDocument,
  MotionHeader,
  MotionMetaTags,
  MotionSidebar,
  MotionToolbar,
} from '../../components'

export const MotionRoot = gql`
  query motionRoot($docId: NumericID!, $appPageId: String = "web-docview-motion") {
    root {
      document: documentByNumericID(docId: $docId, artifact: "PECA") {
        docId
        url
        slug
        status
        isActive
        readingTime
        hasCreditsToViewDocument: viewerCanUseFeature(featureCode: "view_lr_content_1000")
        canCopyContent: viewerCanUseFeature(featureCode: "copy_pecas_content")
        text(highlight: true)
        viewerCanAccessFullDocument
        lawsuitMotionTheme
        boxResourceId

        ...Docview_document
        ...MotionHeader_document
        ...ViewLockContext_document
        ...ViewLockWrapper_document
        ...MotionDocument_document
        ...RecommendedDocuments_document
        ...MotionToolbar_document
        ...MotionAppbar_document
        ...MotionSidebar_document
        ...LawsuitSubjects_document
        ...MotionBreadcrumb_document
        ...MotionMetaTags_document
      }

      viewer: me {
        pid
        boxProfileInfo {
          linkedAccount
        }
        hasPaidPlan
        viewContentBlocked: isBlockedFeature(featureCode: "view_lr_content_1000")

        ...Docview_viewer
        ...ViewLockContext_viewer
        ...ViewLockWrapper_viewer
        ...MotionDocument_viewer
        ...MotionToolbar_viewer
        ...MotionSidebar_viewer
      }
      ...ServerSidePersistentAlertBanner_root
    }
  }

  ${Docview.fragments.document}
  ${MotionHeader.fragments.document}
  ${ViewLockContext.fragments.document}
  ${ViewLockWrapper.fragments.document}
  ${MotionDocument.fragments.document}
  ${RecommendedDocuments.fragments.document}
  ${MotionToolbar.fragments.document}
  ${MotionAppbar.fragments.document}
  ${MotionSidebar.fragments.document}
  ${LawsuitSubjects.fragments.document}
  ${MotionBreadcrumb.fragments.document}
  ${MotionMetaTags.fragments.document}

  ${Docview.fragments.viewer}
  ${ViewLockContext.fragments.viewer}
  ${ViewLockWrapper.fragments.viewer}
  ${MotionDocument.fragments.viewer}
  ${MotionToolbar.fragments.viewer}
  ${MotionSidebar.fragments.viewer}
  ${ServerSidePersistentAlertBanner.fragments.root}
`
